import "../../css/master.css";
import "../../css/app.css";
import "../../css/custom.css";
import { useNavigate } from 'react-router-dom';
import MainComponent from "./main_component";

function FccLogin() {

    document.title = "Web問い合わせシステム ご案内| ファーストコンタクトセンター";
    const navigate = useNavigate();

    function buttonPartnerBridge() {
        window.location.href = process.env.REACT_APP_PB_URL;
    }

    function buttonDWP() {
        navigate("/dwp_login")
    }

    return (
        <MainComponent buttonPartnerBridge={buttonPartnerBridge} buttonDWP={buttonDWP} />
    );
}


export default FccLogin;